import script from "./VirusCarePage.vue?vue&type=script&setup=true&lang=js"
export * from "./VirusCarePage.vue?vue&type=script&setup=true&lang=js"

import "./VirusCarePage.vue?vue&type=style&index=0&id=3265f01e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3265f01e"]])

export default __exports__